/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as SubmitRouteImport } from "./routes/submit";
import { Route as SearchRouteImport } from "./routes/search";
import { Route as ScraperPolicyRouteImport } from "./routes/scraper-policy";
import { Route as PrivacyRouteImport } from "./routes/privacy";
import { Route as NewRouteImport } from "./routes/new";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AlertsRouteImport } from "./routes/alerts";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as UserIdRouteImport } from "./routes/user.$id";
import { Route as TagSlugRouteImport } from "./routes/tag.$slug";
import { Route as CategorySlugRouteImport } from "./routes/category.$slug";
import { Route as DealIdSlugRouteImport } from "./routes/deal.$id.$slug";

const SubmitRoute = SubmitRouteImport.update({
  id: "/submit",
  path: "/submit",
  getParentRoute: () => rootRouteImport,
} as any);
const SearchRoute = SearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => rootRouteImport,
} as any);
const ScraperPolicyRoute = ScraperPolicyRouteImport.update({
  id: "/scraper-policy",
  path: "/scraper-policy",
  getParentRoute: () => rootRouteImport,
} as any);
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any);
const NewRoute = NewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AlertsRoute = AlertsRouteImport.update({
  id: "/alerts",
  path: "/alerts",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const UserIdRoute = UserIdRouteImport.update({
  id: "/user/$id",
  path: "/user/$id",
  getParentRoute: () => rootRouteImport,
} as any);
const TagSlugRoute = TagSlugRouteImport.update({
  id: "/tag/$slug",
  path: "/tag/$slug",
  getParentRoute: () => rootRouteImport,
} as any);
const CategorySlugRoute = CategorySlugRouteImport.update({
  id: "/category/$slug",
  path: "/category/$slug",
  getParentRoute: () => rootRouteImport,
} as any);
const DealIdSlugRoute = DealIdSlugRouteImport.update({
  id: "/deal/$id/$slug",
  path: "/deal/$id/$slug",
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/alerts": typeof AlertsRoute;
  "/login": typeof LoginRoute;
  "/new": typeof NewRoute;
  "/privacy": typeof PrivacyRoute;
  "/scraper-policy": typeof ScraperPolicyRoute;
  "/search": typeof SearchRoute;
  "/submit": typeof SubmitRoute;
  "/category/$slug": typeof CategorySlugRoute;
  "/tag/$slug": typeof TagSlugRoute;
  "/user/$id": typeof UserIdRoute;
  "/deal/$id/$slug": typeof DealIdSlugRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/alerts": typeof AlertsRoute;
  "/login": typeof LoginRoute;
  "/new": typeof NewRoute;
  "/privacy": typeof PrivacyRoute;
  "/scraper-policy": typeof ScraperPolicyRoute;
  "/search": typeof SearchRoute;
  "/submit": typeof SubmitRoute;
  "/category/$slug": typeof CategorySlugRoute;
  "/tag/$slug": typeof TagSlugRoute;
  "/user/$id": typeof UserIdRoute;
  "/deal/$id/$slug": typeof DealIdSlugRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/alerts": typeof AlertsRoute;
  "/login": typeof LoginRoute;
  "/new": typeof NewRoute;
  "/privacy": typeof PrivacyRoute;
  "/scraper-policy": typeof ScraperPolicyRoute;
  "/search": typeof SearchRoute;
  "/submit": typeof SubmitRoute;
  "/category/$slug": typeof CategorySlugRoute;
  "/tag/$slug": typeof TagSlugRoute;
  "/user/$id": typeof UserIdRoute;
  "/deal/$id/$slug": typeof DealIdSlugRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/alerts"
    | "/login"
    | "/new"
    | "/privacy"
    | "/scraper-policy"
    | "/search"
    | "/submit"
    | "/category/$slug"
    | "/tag/$slug"
    | "/user/$id"
    | "/deal/$id/$slug";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/alerts"
    | "/login"
    | "/new"
    | "/privacy"
    | "/scraper-policy"
    | "/search"
    | "/submit"
    | "/category/$slug"
    | "/tag/$slug"
    | "/user/$id"
    | "/deal/$id/$slug";
  id:
    | "__root__"
    | "/"
    | "/alerts"
    | "/login"
    | "/new"
    | "/privacy"
    | "/scraper-policy"
    | "/search"
    | "/submit"
    | "/category/$slug"
    | "/tag/$slug"
    | "/user/$id"
    | "/deal/$id/$slug";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AlertsRoute: typeof AlertsRoute;
  LoginRoute: typeof LoginRoute;
  NewRoute: typeof NewRoute;
  PrivacyRoute: typeof PrivacyRoute;
  ScraperPolicyRoute: typeof ScraperPolicyRoute;
  SearchRoute: typeof SearchRoute;
  SubmitRoute: typeof SubmitRoute;
  CategorySlugRoute: typeof CategorySlugRoute;
  TagSlugRoute: typeof TagSlugRoute;
  UserIdRoute: typeof UserIdRoute;
  DealIdSlugRoute: typeof DealIdSlugRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/submit": {
      id: "/submit";
      path: "/submit";
      fullPath: "/submit";
      preLoaderRoute: typeof SubmitRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/search": {
      id: "/search";
      path: "/search";
      fullPath: "/search";
      preLoaderRoute: typeof SearchRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/scraper-policy": {
      id: "/scraper-policy";
      path: "/scraper-policy";
      fullPath: "/scraper-policy";
      preLoaderRoute: typeof ScraperPolicyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/privacy": {
      id: "/privacy";
      path: "/privacy";
      fullPath: "/privacy";
      preLoaderRoute: typeof PrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/new": {
      id: "/new";
      path: "/new";
      fullPath: "/new";
      preLoaderRoute: typeof NewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/alerts": {
      id: "/alerts";
      path: "/alerts";
      fullPath: "/alerts";
      preLoaderRoute: typeof AlertsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/user/$id": {
      id: "/user/$id";
      path: "/user/$id";
      fullPath: "/user/$id";
      preLoaderRoute: typeof UserIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/tag/$slug": {
      id: "/tag/$slug";
      path: "/tag/$slug";
      fullPath: "/tag/$slug";
      preLoaderRoute: typeof TagSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/category/$slug": {
      id: "/category/$slug";
      path: "/category/$slug";
      fullPath: "/category/$slug";
      preLoaderRoute: typeof CategorySlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/deal/$id/$slug": {
      id: "/deal/$id/$slug";
      path: "/deal/$id/$slug";
      fullPath: "/deal/$id/$slug";
      preLoaderRoute: typeof DealIdSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlertsRoute: AlertsRoute,
  LoginRoute: LoginRoute,
  NewRoute: NewRoute,
  PrivacyRoute: PrivacyRoute,
  ScraperPolicyRoute: ScraperPolicyRoute,
  SearchRoute: SearchRoute,
  SubmitRoute: SubmitRoute,
  CategorySlugRoute: CategorySlugRoute,
  TagSlugRoute: TagSlugRoute,
  UserIdRoute: UserIdRoute,
  DealIdSlugRoute: DealIdSlugRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
